import React from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import RoundTag, { TagContentType } from 'particles/Tag'
import Text from 'particles/Text'

interface StringProps {
    value: string
    color?: string
}

interface GridCellProps {
    stringProps: StringProps
}

const contentTypeMap: Record<string, TagContentType> = {
    nano: 'positive',
    micro: 'warning',
    macro: 'negative',
    mega: 'negative',
}

const GridCell = React.memo(function GridCell(props: GridCellProps) {
    const { stringProps } = props

    if (!stringProps?.value) {
        return <Text scale="caption500">-</Text>
    }

    const formatted = stringProps.value[0].toUpperCase() + stringProps.value.slice(1)
    return <RoundTag label={formatted} contentType={contentTypeMap[stringProps.value.toLowerCase()] ?? 'neutral'} />
})

export const ProfileTypeCell = (params: GridRenderCellParams) => {
    const stringProps: StringProps = params.value as StringProps
    return <GridCell stringProps={stringProps} />
}
